import axios from "axios";
// import { BASE_URL, ENDPOINTS } from "../constants/apiUrls";
import { endpointUrl } from "../endpoints";

// Fetch all products
export const fetchProducts = async () => {
  const response = await axios.get(endpointUrl.getProducts);
  console.log("hello", response.data);
  return response.data;
};
